// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__1fCDF","bottomLogo":"Login_bottomLogo__1WoBM","logo":"Login_logo__hVE_W","loginCard":"Login_loginCard__Ck0Kv"};